import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateChildFn, Router, UrlTree } from '@angular/router';
import { RegimenClass } from '@cureskin/api-client/src/server-api';
import { ConnectionService } from '@services/connection-service';
import { RegimenService } from '@services/regimen-service/regimen.service';
import { AppConfig } from 'client/app/app.config';
import { getDisplayState } from 'client/app/user/user-view/user-regimen/regimen.utils';
import {
  REGIMEN_QUERY_PARAMS,
  REGIMEN_ROUTE_PATHS,
  REGIMEN_TAB_TYPES,
  REGIMEN_VIEW_STATES,
} from 'client/app/user/user-view/user-regimen/regimen.constants';

export const regimenViewStateGuard: CanActivateChildFn = async (
  route: ActivatedRouteSnapshot,
): Promise<boolean | UrlTree> => {
  const conn = inject(ConnectionService);
  const regimenService = inject(RegimenService);
  const router = inject(Router);
  const appConfig = inject(AppConfig);

  const regimenClass = (route.queryParams[REGIMEN_QUERY_PARAMS.CLASS] as RegimenClass)
    || appConfig.Shared.Regimen.Class.FACE;

  if (regimenClass === REGIMEN_TAB_TYPES.OTHERS) return true;

  const regimens = await regimenService.getRegimens();
  const regimen = regimens.find((r: { class?: string }): boolean => r.class === regimenClass) ?? null;

  if (regimen?.objectId) return true;

  const consultationSession = await conn.findConsultationSession(regimenClass);
  const state = getDisplayState(null, { consultationSession });

  if (state === REGIMEN_VIEW_STATES.EMPTY) {
    return router.createUrlTree([REGIMEN_ROUTE_PATHS.MAIN_CONCERN], {
      queryParams: {
        [REGIMEN_QUERY_PARAMS.CLASS]: regimenClass,
        [REGIMEN_QUERY_PARAMS.REDIRECT_ON_BACK]: '/home',
      },
    });
  }

  return router.createUrlTree([REGIMEN_ROUTE_PATHS.ROOT], {
    queryParams: { [REGIMEN_QUERY_PARAMS.CLASS]: regimenClass },
  });
};
